module.exports = __webpack_public_path__ + "static/media/pagorealizados.d68365b2.png";